import { Process } from "@/services/backend/processes/types/process";
import t from "@/lang/lang";
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
} from "@/shared/components/ui/sidebar";
import { CloseProcessSidebarMenu } from "@/routes/processes/[processId]/_components/close-process-sidebar-menu";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";

export function ProcessActionsSidebarGroup({ process }: { process: Process }) {
  const canAccess = useFeatureAuth("gsm.processes.process.close");

  if (!canAccess) {
    return null;
  }

  return (
    <SidebarGroup>
      <SidebarGroupLabel>{t("Vorgang")}</SidebarGroupLabel>
      <SidebarGroupContent>
        <CloseProcessSidebarMenu processId={process!.id} />
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
